import { ChangeDetectionStrategy, Component, output } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

import { AddEudrDdsDialogResponseEnum } from "@shared/enums";
import { EudrDds } from "@shared/interfaces/eudr-dds.interface";
import { CustomValidators } from "@shared/validators";

@Component({
  standalone: false,
  selector: "app-add-eudr-dds-dialog",
  templateUrl: "./add-eudr-dds-dialog.component.html",
  styleUrls: ["./add-eudr-dds-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddEudrDdsDialogComponent {
  readonly translations = {
    title: $localize`:@@action.delivery-overlay.ddsdialog.title:Add EUDR due diligence statement`,
    buttons: {
      createNew: $localize`:@@action.delivery-overlay.ddsdialog.createnewdds:Create new`,
      createNewHint: $localize`:@@action.delivery-overlay.ddsdialog.createnewdds.hint:Will create a new due diligence statement based on the record data.`,
      addExisting: $localize`:@@action.delivery-overlay.ddsdialog.addexistingdds:Add existing: TRACES DDS identifier`,
      addExistingHint: $localize`:@@action.delivery-overlay.ddsdialog.addexistingdds.hint:Allows to add an existing due diligence statement from TRACES based on the DDS identifier.`,
      addExistingReferenceNumber: $localize`:@@action.delivery-overlay.ddsdialog.addexistingdds.reference:Add existing: Reference number`,
      addExistingReferenceNumberHint: $localize`:@@action.delivery-overlay.ddsdialog.addexistingdds.reference.hint:Allows to add a due diligence statement in the absence of a DDS identifier from TRACES. Does not support getting the latest status of the DDS from TRACES, but can be referenced in other DDSs (if the verification number is provided).`,
    },
    internalReferenceNumber: $localize`:@@action.delivery-overlay.ddsdialog.internalreference:Internal reference number`,
    ddsIdentifier: $localize`:@@action.delivery-overlay.ddsdialog.ddsidentifier:TRACES DDS identifier`,
    ddsIdentifierTooltip: $localize`:@@action.delivery-overlay.ddsdialog.ddsidentifier.tooltip:The identifier of the due diligence statement in TRACES.`,
    note: $localize`:@@action.delivery-overlay.ddsdialog.note:Note: This will not get the product / production place(s) information of this DDS from TRACES, as their integration does not support providing this info. This will simply add a reference of that DDS to your delivery.`,
  };

  readonly addExistingDdsFormGroup = new FormGroup({
    internalReferenceNumber: new FormControl(null as string, [CustomValidators.required]),
    ddsIdentifier: new FormControl(null as string, [CustomValidators.required]),
  });

  readonly addedExistingDdsIdentifier = output<EudrDds.DdsReference>();

  constructor(public dialogRef: MatDialogRef<AddEudrDdsDialogComponent>) {}

  onClose() {
    this.dialogRef.close();
  }

  onClickGenerateEudrReport() {
    this.dialogRef.close(AddEudrDdsDialogResponseEnum.GENERATE_NEW);
  }

  onAddExistingDdsIdentifier() {
    this.dialogRef.close(AddEudrDdsDialogResponseEnum.ADD_EXISTING_DDS_IDENTIFIER);
  }

  onAddExistingReferenceNumber() {
    this.dialogRef.close(AddEudrDdsDialogResponseEnum.ADD_EXISTING_REFERENCE_NUMBER);
  }
}
